<!-- 裂变工具 参与者 -->
<template>
    <div>
        <el-page-header class="page-header" @back="goBack" content="参与者">
        </el-page-header>
        <nav class="navbar">
            <div class="nav-l">
                <el-input clearable style="width: 27.0rem; " placeholder="请搜索参与人" prefix-icon="el-icon-search" v-model="q" @change="getList()">
                </el-input>
                <el-button slot="append" type="primary" @click="getList()">查询</el-button>
            </div>
            <div class="nav-r">
              <el-select v-model="select_value" placeholder="请选择任务状态" @change="getList()">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </nav>
        <div class="main">
            <el-table :data="tableData" border>
                <el-table-column prop="username" label="参与人">
                    <template slot-scope="scope">
                        <div class="userinfo">
                            <el-image style="width: 4.2rem; height: 4.2rem; border-radius: .4rem" :src="scope.row.image" :preview-src-list="[scope.row.image]" fit="scale-down"></el-image>
                            <span style="margin-left: 1.0rem">{{
                scope.row.username
              }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="if_complete_name" label="任务状态" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.if_complete == 0" style="color: #409EFF">
                            {{ scope.row.if_complete_name }}
                        </span>
                        <span v-else-if="scope.row.if_complete == 1" style="color: #67C23A">
                            {{ scope.row.if_complete_name }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="percent_completed" label="有效助力人数" width="120">
                </el-table-column>
                <el-table-column prop="createtime" label="参与时间" width="160">
                </el-table-column>
                <el-table-column prop="if_prize_name" label="奖品处理情况" width="180">
                    <template slot-scope="scope">
                        <span v-if="scope.row.if_prize == 0" style="color: #F56C6C">
                            {{ scope.row.if_prize_name }}
                        </span>
                        <span v-else-if="scope.row.if_prize == 1" style="color: #67C23A">
                            {{ scope.row.if_prize_name }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="prize_address" label="联系地址">
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="240">
                    <template slot-scope="scope">
                        <el-button style="margin: .6rem" @click="onHistory(scope.row)" size="mini" type="text">
                            助力记录
                        </el-button>
                        <el-button v-if="scope.row.if_complete == 1" style="margin: .6rem" @click="onDialogVisible(scope.row)" size="mini" type="text">
                            处理奖品
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="paging">
                <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" :page-sizes="[10,20,50,100]" :auto-scroll="false" @pagination="getList" />
            </div>
            <el-dialog title="处理奖品" center :visible.sync="dialogVisible">
                <div>
                    <el-input type="textarea" autosize="true" v-model="prize_address" placeholder="请输入中奖人联系地址"></el-input>
                </div>
                <div slot="footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="onUpdatePrize">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
export default {
    name: "fissionAssistant",
    components: {},

    data() {
      return {
          options: [{
                value: 3,
                label: '全部'
            },{
                value: 0,
                label: '助力中'
            }, {
                value: 1,
                label: '助力完成'
          },],//select下拉数据

            select_value:'',
            dialogVisible: false,
            tableData: [],
            total: 0,
            listQuery: {
                page: 1,
                limit: 20,
            },
            prize_address: "",
            currentRow: {},
            q: ""
        };
    },

    computed: {},

    mounted() {
        this.getList();
    },

    methods: {
        goBack() {
            this.$router.go(-1);
        },
        onDialogVisible(row) {
            this.currentRow = row;
            if (row.prize_address) {
                this.prize_address = row.prize_address;
            } else {
                this.prize_address = ""
            }

            this.dialogVisible = true;
        },
        async onUpdatePrize(row) {
            const { data: res } = await this.axios({
                url: "/crm/ActivityFission/updatePrize",
                method: "POST",
                data: this.qs.stringify({
                    usertoken: this.tooken.usertoken,
                    account_id: this.tooken.account_id,
                    phone: this.tooken.phone,
                    id: this.currentRow.id,
                    prize_address: this.prize_address,
                }),
            });
            if (res.code == 1) {
                this.dialogVisible = false;
                this.$message.success(res.msg);
                this.getList();
            } else if (res.code == 0) {
                this.$message.error(res.msg);
            }
        },
        onHistory(row) {
            this.$router.push({
                name: "fissionParticipate",
                query: {
                    fission_id: this.$route.query.id,
                    card_user_id: row.card_users_id,
                },
            });
        },
        async getList() {
            const { data: res } = await this.axios({
                url: "/crm/ActivityFission/getAssistant",
                method: "POST",
                data: this.qs.stringify({
                    usertoken: this.tooken.usertoken,
                    account_id: this.tooken.account_id,
                    phone: this.tooken.phone,
                    page: this.listQuery.page,
                    number_page: this.listQuery.limit,
                    id: this.$route.query.id,
                    username: this.q,
                  if_complete: this.select_value === '' ? 3 : this.select_value
                }),
            });
            if (res.code == 1) {
                this.tableData = res.data.data;
                this.total = res.data.total;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.userinfo {
    display: flex;
    align-items: center;
}
.main {
    padding: 2rem;
    background-color: #ffffff;

    margin-top: -1.5rem;
    border-radius: 0 0 0.8rem 0.8rem;
}
.navbar {
    padding: 2rem;
    background-color: #ffffff;
    border-radius: 0.8rem 0.8rem 0 0;
}
.el-page-header {
    position: relative;
    top: -0.4rem;
}
.el-table {
    margin-top: 0 !important;
}
::v-deep .el-table__fixed-right::before,
.el-table__fixed::before {
    background: none;
}
.navbar{
  justify-content: flex-start;
  .nav-l{
    margin-right: 2rem;
  }
}
::v-deep .el-table .cell{
  display: flex;
}
</style>
